var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.83374 9.16602H7.50041V10.8327H5.83374V9.16602ZM5.83374 12.4993H7.50041V14.166H5.83374V12.4993ZM9.16707 9.16602H10.8337V10.8327H9.16707V9.16602ZM9.16707 12.4993H10.8337V14.166H9.16707V12.4993ZM12.5004 9.16602H14.1671V10.8327H12.5004V9.16602ZM12.5004 12.4993H14.1671V14.166H12.5004V12.4993Z",
    fill: "#1C3D5D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16667 18.3327H15.8333C16.7525 18.3327 17.5 17.5852 17.5 16.666V4.99935C17.5 4.08018 16.7525 3.33268 15.8333 3.33268H14.1667V1.66602H12.5V3.33268H7.5V1.66602H5.83333V3.33268H4.16667C3.2475 3.33268 2.5 4.08018 2.5 4.99935V16.666C2.5 17.5852 3.2475 18.3327 4.16667 18.3327ZM15.8333 6.66602L15.8342 16.666H4.16667V6.66602H15.8333Z",
    fill: "#1C3D5D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar-icon.a230aefa6b3b18985c5ac0348be5cc49.svg";
export { ForwardRef as ReactComponent };